import { createAction, props } from '@ngrx/store';
export const setReportDescription = createAction('[Custom PDF Report Builder] Set Report Description', props());
